import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { Input, version2 } from 'ui-components/components/input';
import { INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';
import { LabelWithRequiredIndicator } from 'ui-components/components/label-with-required-indicator';
import { useShipFromContext } from '../../contexts/ship-from-context';

import messages from '../messages';

const INPUT_NAME = 'shipFromLocationName';

const ShipFromName = () => {
  const { shipFrom, updateShipFrom, validationErrors, showValidation, trackInputChange, trackInputClick } = useShipFromContext();
  const intl = useIntl();
  const [touched, setTouched] = useState(false);

  const onClick = useCallback(() => trackInputClick(INPUT_NAME), [trackInputClick]);
  const onChange = useCallback(
    ({ target: { value } }) => {
      updateShipFrom({
        name: value,
      });
    },
    [updateShipFrom],
  );

  const onBlur = useCallback(
    ({ target: { value } }) => {
      setTouched(true);
      trackInputChange(INPUT_NAME, value);
    },
    [trackInputChange],
  );

  const error = touched || showValidation ? validationErrors?.name : null;
  const inlineMessage = error?.message && intl.formatMessage(error.message);
  const inlineMessageType = inlineMessage ? INLINE_MESSAGE_TYPES.error : undefined;

  // Create label with required indicator (Location Name is always required for ship-from)
  const baseLabel = intl.formatMessage(messages.name);
  const label = <LabelWithRequiredIndicator>{baseLabel}</LabelWithRequiredIndicator>;

  return (
    <Input
      inlineMessage={inlineMessage}
      inlineMessageType={inlineMessageType}
      label={label}
      name={INPUT_NAME}
      onBlur={onBlur}
      onChange={onChange}
      onClick={onClick}
      value={shipFrom.name}
      version={version2}
    />
  );
};

export default ShipFromName;
